import { useTranslation } from 'react-i18next';

import * as St from './OrderSummaryPage.styles';
import useProductImages from './hooks/useProductImages';

import PrintEstimationButtons from '~/UI/components/organisms/PrintEstimationButtons';
import { useIsLaminateProductOnlySelected } from '~/api/easy-estimator-api/materials-api/hooks/useIsLaminateProductOnlySelected';
import PageTitle from '~atoms/PageTitle';
import Carousel from '~molecules/Carousel';
import AlsoLikeSection, { type ItemData } from '~organisms/AlsoLikeSection';
import OrderInvoice from '~organisms/OrderInvoice';
import SaveEstimateSection from '~organisms/SaveEstimateSection';
import WhatToExpectSection from '~organisms/WhatToExpectSection';

const thumbnailSrc = 'https://picsum.photos/350/180';
const imgSrc = 'https://picsum.photos/544/315';
const description =
  'Luminous white background with bold, dynamic light grey and gold veining';
const cards: ItemData[] = [
  {
    name: 'Sugarbrush',
    price: 4254.08,
    material: 'Quartz',
    img: { src: `${thumbnailSrc}?1`, alt: 'alt text' },
    description,
    originalPricePerSqFt: 68,
    discountedPricePerSqFt: 62.56,
    discountPercentage: 8,
    promoEndDate: new Date('8-27-23'),
    isTrending: true,
    images: [
      { src: `${imgSrc}?1`, alt: 'alt text' },
      { src: `${imgSrc}?2`, alt: 'alt text' },
    ],
    features: ['Movement', 'Polished', 'Resistant'],
  },
  {
    name: 'Sammamish',
    material: 'Quartz',
    img: { src: `${thumbnailSrc}?3`, alt: 'alt text' },
    description,
    isTrending: true,
    originalPricePerSqFt: 68,
    discountedPricePerSqFt: 62.56,
    discountPercentage: 8,
    price: 1233.45,
    images: [
      { src: `${imgSrc}?3`, alt: 'alt text' },
      { src: `${imgSrc}?4`, alt: 'alt text' },
    ],
    features: ['Movement', 'Polished', 'Resistant'],
  },
  {
    name: 'Cosmic vapor',
    originalPricePerSqFt: 68,
    price: 1233.45,
    material: 'Quartz',
    img: { src: `${thumbnailSrc}?5`, alt: 'alt text' },
    description,
    isTrending: true,
    images: [
      { src: `${imgSrc}?5`, alt: 'alt text' },
      { src: `${imgSrc}?6`, alt: 'alt text' },
    ],
    features: ['Movement', 'Polished', 'Resistant'],
  },
];

const OrderSummaryPage = (): JSX.Element => {
  const { t } = useTranslation();

  // EE3-630 - Feature flag to control "You may also like" section visibility
  const showAlsoLikeSection = false;
  const { images } = useProductImages();
  const isLaminateProductOnlySelected = useIsLaminateProductOnlySelected();

  return (
    <St.OrderSummaryContainer>
      <St.CarouselArea>
        <PageTitle>{t('ORDER_SUMMARY.ORDER_SUMMARY')}</PageTitle>
        <Carousel images={images} />
      </St.CarouselArea>
      <St.OrderDetailsCard>
        <PrintEstimationButtons />
        <OrderInvoice showInstallationFee={!isLaminateProductOnlySelected} />
        <SaveEstimateSection />
      </St.OrderDetailsCard>
      <St.WhatToExpectArea>
        <WhatToExpectSection />
      </St.WhatToExpectArea>
      {showAlsoLikeSection && (
        <St.YouMayAlsoLikeArea>
          <AlsoLikeSection data={{ title: 'You may also like', cards }} />
        </St.YouMayAlsoLikeArea>
      )}
    </St.OrderSummaryContainer>
  );
};

export default OrderSummaryPage;
